module.exports = __webpack_public_path__ + "static/media/KiTa_FöVe_Beitrittserklärung_2025.68131835.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/docs/KiTa_FöVe_Beitrittserklärung_2025.pdf
// module id = 100
// module chunks = 0